module.exports = __webpack_public_path__ + "img/20210906-1630910942791827.901950ad.jpg";